module.exports = require("./es-DO.d.ts");